export default __webpack_public_path__ + "static/media/avatar.aec7fdad.jpg";